"use client"

import { useEffect } from "react"

/**
 * Regista o service worker para que a ementa possa ser instalada como app
 * no telemóvel do cliente. Sem isto, o Chrome nunca oferece "Instalar app".
 * O SW não guarda HTML em cache (ver public/sw.js).
 */
export function PwaRegister() {
  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return
    const id = setTimeout(() => {
      navigator.serviceWorker.register("/sw.js").catch(() => {
        /* sem service worker a ementa continua a funcionar */
      })
    }, 1200)
    return () => clearTimeout(id)
  }, [])

  return null
}
